<ng-container *ngIf="questions$ | async  as options; else skeleton">


  <mat-list *ngIf="options?.length; else noData">
    <mat-list-item role="listitem"
      *ngFor="let option of options;trackBy:trackByFn"
      (click)="openQuestion(option)"
      class="cursor-pointer">
      <div mat-line>
        <span class="overflow-text">
          {{ option.questionText }}
        </span>

      </div>
      <div class="d-flex justify-content-between"
        mat-line>
        <span class="pt-2 d-flex col-gap-1">

          <small class="d-flex align-items-center">
            <mat-icon fontSet="material-icons-outlined"
              inline>
              pending_actions
            </mat-icon>

            {{ ('PHASES.' +(option?.phase | lowercase)) | translate }}
          </small>

          <ng-container *ngIf="option.sessions?.length">
            <small class="d-flex align-items-center">
              <mat-icon fontSet="material-icons-outlined"
                class="mt-1"
                inline>
                calendar_month
              </mat-icon>

              {{'forms.common.sessions' | translate }} : {{option.sessions?.length}}
            </small>

            <small class="d-flex align-items-center">
              <mat-icon fontSet="material-icons-outlined"
                class="mt-1"
                inline>
                group
              </mat-icon>

              {{'forms.common.members' | translate }} : {{ option.sessions | membersLength}}
            </small>

          </ng-container>

        </span>
        <span *ngIf="!disabled && !viewOnly">
          <button mat-icon-button
            [matTooltip]="'forms.common.edit' | translate"
            (click)=" editQuestion(option , $event)">
            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
          </button>
          <button mat-icon-button
            [matTooltip]="'forms.common.delete' | translate"
            (click)="deleteQuestion(option , $event)">
            <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
          </button>
        </span>
      </div>
      <mat-divider></mat-divider>
    </mat-list-item>

  </mat-list>



</ng-container>


<ng-template #noData>
  <div class="pb-4 d-flex flex-column justify-content-center align-items-center h-100 bg-light  text-center">
    <div class=" ">
      <h4>{{ 'ERRORS.NoDataFound' | translate }}</h4>
    </div>
  </div>
</ng-template>

<ng-template #skeleton>
  <formio-skeleton width="60%"
    styleClass="mb-2"></formio-skeleton>
  <formio-skeleton width="80%"
    styleClass="mb-2"></formio-skeleton>
  <formio-skeleton width="20%"
    styleClass="mb-2"></formio-skeleton>
  <formio-skeleton width="75%"
    styleClass="mb-2"></formio-skeleton>
  <formio-skeleton styleClass="mb-2"></formio-skeleton>
</ng-template>
